<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.videoRecord')"
    resource="video_records"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/video_records.js';
import _ from 'lodash';
import qs from 'qs';

@Component
export default class VideoRecords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [

    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'status',
      'account',
      'fund',
      type === 'show' && 'video',
      'reject_reason',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'account_id',
      'fund_id',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handlePreview = async () => {
      try {
        const params = {
          page: 'pages/record/index',
          scene: qs.stringify({
            id: row.id
          }),
          check_path: process.env.VUE_APP_ENV === 'production'
        }
        const resBlob = await this.$request.get(`bs_wechat_mini_program_application/${this.$root.user.current_role.application_id}/wxacodes/getwxacodeunlimit`, { params }, { responseType: 'blob', $alert: false });
        const qrcodeUrl = window.URL.createObjectURL(resBlob);
        this.$msgbox({
          title: this.$t('customPage.preview'),
          message: this.$createElement('el-image', { props: { src: qrcodeUrl }, domProps: { style: 'display: block;width: 300px;margin: 0 auto;' } }),
          showCancelButton: false,
          confirmButtonText: this.$t('close'),
        });
      } catch (e) {
        const result = _.get(e, 'response.data');
        if (result instanceof Blob && result.type === 'application/json') {
          result.text().then(res => {
            const { error_message } = JSON.parse(res);
            this.$msgbox.alert(error_message, { title: this.$t('error') });
          });
          return;
        }
        this.$msgbox(e.message, { title: this.$t('error') })
      }
    }

    const handleApproved = async (id) => {
      await this.$autoLoading(this.$request.put(`/video_records/${id}/approve`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'video_records.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'video_records.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      row.status === 'auditing' && {
        component: 'confirmButton',
        props: {
          label: '通过',
          type: 'primary',
          can: 'video_records.update'
        },
        on: {
          confirm: () => handleApproved(row.id)
        }
      },
      row.status === 'auditing' && {
        component: 'dialogFormButton',
        props: {
          label: '拒绝',
          can: 'video_records.update',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'reject_reason',
              renderCell: {
                required: true,
                hint: '微信订阅消息仅能显示前20个字符'
              }
            }
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/video_records/${row.id}/reject`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      {
        component: 'button',
        props: {
          label: '小程序码'
        },
        on: {
          click: () => handlePreview()
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/video_records',
    name: 'video_records.index',
    component: VideoRecords,
    props: {
      type: 'index',
    }
  },
  {
    path: '/video_records/new',
    name: 'video_records.new',
    component: VideoRecords,
    props: {
      type: 'new',
    }
  },
  {
    path: '/video_records/:id',
    name: 'video_records.show',
    component: VideoRecords,
    props: {
      type: 'show',
    }
  },
  {
    path: '/video_records/:id/edit',
    name: 'video_records.edit',
    component: VideoRecords,
    props: {
      type: 'edit'
    }
  }
]
</script>
